<mat-progress-bar class="progress-margin" color="primary" *ngIf="loading" mode="indeterminate">
</mat-progress-bar>
<div class="card-container mat-elevation-z1">
    <form class="order-control" [formGroup]="reservationOrderFormGroup">
        <div class="card-content">

            <div class="card-box-medium margin-right-small">
                <h4>Prácticas</h4>
                <mat-divider></mat-divider>
                <table class="order-control margin-top-medium" mat-table [dataSource]="practicesRegionDataSource">
                    <tr mat-header-row class="table-header" *matHeaderRowDef="displayPracticesRegionColumns"></tr>
                    <tr class="table-cell" mat-row *matRowDef="let row; let i = index; columns: displayPracticesRegionColumns;"></tr>

                    <ng-container matColumnDef="Name">
                        <th mat-header-cell class="table-header" *matHeaderCellDef> </th>
                        <td (click)="setIndex(index)" mat-cell [ngClass]="setMyStyles(index)" *matCellDef="let row; let index = index" [formGroupName]="index">
                            {{ displayPracticeName(index) }}
                        </td>
                    </ng-container>
                </table>
            </div>
            <div class="card-box-medium margin-right-small">
                <h4>Orden</h4>
                <mat-divider></mat-divider>
                <div formArrayName="ServiceReservations">
                    <div *ngFor="let item of serviceReservationsArrayGroup.controls; let pointIndex=index" [formGroupName]="pointIndex">

                        <div *ngIf="pointIndex == getIndex && preAuthorizationRequired" class="order-control">
                            <br>
                            <h3 class="in-line">Pre autorización </h3>


                            <mat-form-field *ngIf="credentialRequired" class="card-inline margin-right-small">
                              <mat-label>Número de afiliado</mat-label>
                              <input
                                type="text"
                                (change)="onCredentialNumberChange($event.target.value)"
                                matInput
                                #credentialNumber
                                formControlName="CredentialNumber"
                              />
                            </mat-form-field>
                            <mat-form-field  *ngIf="tokenRequired" class="card-inline margin-right-small">
                              <mat-label>Código de seguridad</mat-label>
                              <input
                              (change)="onSecurityCodeCredentialNumberChange($event.target.value)"
                                type="text"
                                matInput
                                formControlName="SecurityCodeCredentialNumber"
                              />
                            </mat-form-field>


                            <button class="in-line" type="button" matSuffix *ngIf="!loading" (click)="executePreAuthorization()" mat-mini-fab>
                              <mat-icon>cloud_done</mat-icon>
                          </button>
                        </div>
                        <div *ngIf="canViewMedicaOrderDate && pointIndex == getIndex" class="order-control margin-top-medium">
                            <mat-form-field>
                                <input (dateChange)="onDateChange($event.target.value)" matInput formControlName="DateOrder" #dateOrder [matDatepicker]="pickerOrder" placeholder="Fecha de la orden {{validityDays}}">
                                <mat-datepicker-toggle matSuffix [for]="pickerOrder"></mat-datepicker-toggle>
                                <mat-datepicker #pickerOrder></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div *ngIf="canViewReferringPhysician && pointIndex == getIndex" class="order-control">
                            <referring-physician-autocomplete #referringPhysician formControlName="ReferringPhysician"></referring-physician-autocomplete>
                        </div>
                        <div *ngIf="pointIndex == getIndex" class="order-control">
                            <mat-form-field class="order-control">
                                <textarea (change)="onDiagnosticChange($event.target.value)" class="order-control" matInput formControlName="Diagnostic" maxlength="250" placeholder="Diagnóstico"></textarea>
                            </mat-form-field>
                        </div>
                        <div *ngIf="pointIndex == getIndex" class="order-control">
                            <mat-form-field class="order-control">
                                <textarea (change)="onObservationChange($event.target.value)" class="order-control" matInput formControlName="Observation" maxlength="250" placeholder="Observaciones internas"></textarea>
                            </mat-form-field>
                        </div>
                        <div *ngIf="pointIndex == getIndex" class="order-control">
                          <mat-form-field class="order-control">
                              <textarea (change)="onPatientObservationChange($event.target.value)" class="order-control" matInput formControlName="PatientObservation" maxlength="250" placeholder="Observaciones paciente"></textarea>
                          </mat-form-field>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix">
            <div class="pull-right margin-right-medium margin-top-medium">
                <button *ngIf="!loading" class="card-inline" type="button" (click)="reservationWizardService.cancel()" mat-button>CANCELAR</button>
            </div>
            <div class="card-footer margin-top-medium">
                <button *ngIf="!loading" mat-button color="primary" matStepperPrevious>ANTERIOR</button>
                <button *ngIf="!loading" color="primary" mat-flat-button (click)="save()">SIGUIENTE</button>
            </div>
        </div>

    </form>
</div>
